import { MenuElement } from 'frontend-container/components/Menu/types';

import { acConfig } from '@ac/library-utils/dist/declarations';
import { IconName } from '@ac/web-components';

export const organizationStructureMenu: MenuElement = {
  translation: 'MENU.ORGANIZATION_STRUCTURE.TITLE',
  icon: IconName.structure,
  id: 'menu-organization-structure',
  items: [
    {
      link: `${acConfig.newFrontendUrls.configurationv2}`,
      aliases: [
        `${acConfig.newFrontendUrls.configurationv2}/customers/:customerId/organization-structure`,
      ],
      translation: 'MENU.ORGANIZATION_STRUCTURE.ITEMS.DASHBOARD',
      keyboardShortcutWindows: "alt+ctrl+'",
      keyboardShortcutMac: "⌥+⌘+'",
    },
  ],
};
